export default "<app-rolelist-table>\n    \n</app-rolelist-table>"